import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledHeader = styled('label', {
  color: '$darkGray300',
  fontSize: '$md',
  fontWeight: '$regular',
});

export const LegendContainer = styled(Box, {
  margin: '$10 0',
});

export const Row = styled(Box, {
  alignItems: 'center',
  display: 'flex',

  '&:first-child': {
    paddingBottom: '$4',
  },
});

export const Column = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  marginRight: '56px',
});

export const Container = styled(Box, {
  alignItems: 'flex-end',
  display: 'flex',
  padding: '$8 0 $10 $10',
  width: '70%',
});
